<template>


  <div>

    <div class="fixed-header">


      <input v-model="filterTerm" placeholder="Search...">

      <v-row style="height: 100px;">

        <v-col class="d-flex align-center">
          <v-btn :href="`tel:+601116331800`" color="success" small icon>
            <v-icon>mdi-phone-in-talk</v-icon>
          </v-btn>
        </v-col>

        <v-col class="d-flex align-center">
          <router-link :to="{ name: 'listMyCall' }">list My Call</router-link>
        </v-col>


        <v-col class="d-flex align-center">
          <v-btn @click="printTable">Print PDF</v-btn>
        </v-col>
        <v-col class="d-flex align-center">
          <h3>v1.00</h3>
        </v-col>
        <v-col>
          <v-select v-model="selectedUser" :items="users" item-text="text" item-value="value"
            label="Select a user"></v-select>
        </v-col>
        <v-col>
          <input class="bordered-input " type="text" id="findValue" v-model="findValue">
        </v-col>
        <v-col>
          <button class="bordered-input" @click="jumpToIndex">By Row No.</button>
        </v-col>
        <v-col>
          <button class="bordered-input" @click="findNumber">By Phone Number</button>
        </v-col>
        <v-col>
          <button class="bordered-input" @click="findName">By Name</button>
        </v-col>
        <v-col class="d-flex align-center">

          <CountdownTimer ref="countdown" :seconds="5" :onCountdownFinish="countdownFinished" />

        </v-col>
      </v-row>

      <!-- <div class="search-container">
        <input class="bordered-input half-width" type="text" id="findValue" v-model="findValue">
        <button class="bordered-input" @click="jumpToIndex">By Row No.</button>
        <button class="bordered-input" @click="findNumber">By Phone Number</button>
        <button class="bordered-input" @click="findName">By Name</button>
      </div> -->

      <!-- <v-container>
        <v-select
          v-model="selectedUser"
          :items="users"
          item-value="value"
          item-text="text"
          label="Select a user"
        ></v-select>
      </v-container> -->

      <v-container>
        <v-data-table :pagination="false"
          :headers="[{ title: 'Msg' }, { title: 'No' }, { title: 'project' }, { title: 'source' }, { title: 'name' }, { title: 'Phone' }, { title: 'Occupation' }, { title: 'Email' }, { title: 'Message' }]"
          :items="[currentContact]" class="elevation-1" hide-default-footer>




          <!-- <template v-slot:item="{ item }"> -->

          <template v-slot:item="{ item }">
            <tr>
              <td width="8%"> <input type="text" id="sendmsg" v-model="sendmsg"></td>
              <td> {{ item.no }}</td>
              <td> {{ item.project }}</td>
              <td> {{ item.source }}</td>
              <td style="font-size: 18px;font-weight: bold;"> {{ item.name }}</td>
              <td> {{ item.phoneNumber }}</td>

              <td style="font-size: 18px;font-weight: bold;"> <input type="text" id="sendmsg" v-model="item.occupation">
              </td>

              <td> <input type="text" id="sendmsg" v-model="item.email"></td>

              <td> {{ item.message }}</td>
              <!-- <td style="color: blue;">{{ item.interaction }}</td> -->
            </tr>
          </template>
          <template v-slot:bottom> </template>
        </v-data-table>

        <h2 style="color: blue;"> {{ currentContact.interaction }}</h2>


      </v-container>

    </div>


    <br /><br /><br />
    <br /><br /><br />
    <br /><br /><br />




    <v-row class="d-flex align-center">
      <v-col>
        <button @click="sendwhatsappmessage">Send via WhatsApp</button>
      </v-col>
      <v-col>
        <button @click="startProcessing">Start</button>
      </v-col>

      <v-col>
        <h3>Load JSON</h3>
      </v-col>

      <v-col>
        <v-btn @click="exportToJSON">Export to JSON</v-btn>
      </v-col>
      <v-col>
        <v-btn @click="removeDuplicatePhoneNumbers">Remove Duplicate</v-btn>
      </v-col>
      <v-col>
        <h3>Load CSV</h3>
      </v-col>
      <v-col>


        <input data-v-002fd7de="" type="file" accept=".csv" @change="loadCSVFile" ref="fileInput">

      </v-col>
    </v-row>





    <div>
      <input type="file" @change="loadJSONFile" />
      <div v-if="error" class="error">{{ error }}</div>

      <div class="button-container">
        <button @click="sortContacts('phoneNumber')" class="sort-button">
          Sort by Phone Number ({{ sortOrder.phoneNumber }})
        </button>
        <button @click="sortContacts('name')" class="sort-button">
          Sort by Name ({{ sortOrder.name }})
        </button>
        <button @click="sortContacts('no')" class="sort-button">
          Sort by No ({{ sortOrder.no }})
        </button>
        <button @click="sortContacts('status')" class="sort-button">
          Sort by Status ({{ sortOrder.status }})
        </button>
        <button @click="sortContacts('nextCall')" class="sort-button">
          Sort by Next Call ({{ sortOrder.nextCall }})
        </button>
      </div>

      <!-- Add your contact display logic here -->
    </div>

    <!-- <v-data-table
    @click:row="rowClick" :headers="[{ title: 'Msg' }, { title: 'No' }, { title: 'project' }, { title: 'source' }, { title: 'name' }, { title: 'Phone' }, { title: 'Occupation' }, { title: 'Email' }, { title: 'Message' }]"
      :items="contacts" class="elevation-1" hide-default-footer> -->



    <v-data-table id="tableToPrint" :headers="headers" :items="filteredContacts" class="elevation-1 pdf-container"
      hide-default-footer :items-per-page="1000">

      <template v-slot:item="{ item, index }">
        <!-- <tr v-for="(contact, index) in contacts" :key="index" :class="{ 'selected': currentIndex === index }"> -->

        <tr :class="{ 'highlight': currentIndex === index }" @click="rowClick(index)">
          <td>
            <v-btn @click="removeContact(index)" color="error" small icon>
              <v-icon>mdi-delete</v-icon>
            </v-btn>
          </td>
          <td>
            <v-btn @click="sendViaWhatsApp(item)" color="primary" small icon>
              <v-icon>mdi-whatsapp</v-icon>
            </v-btn>
          </td>
          <td>
            <v-btn @click="makeCall(item)" color="primary" small icon>
              <v-icon>mdi-phone</v-icon>
            </v-btn>
          </td>
          <!-- <td>
            <v-btn :href="`tel:${item.phoneNumber}`" color="success" small icon>
              <v-icon>mdi-phone-in-talk</v-icon>
            </v-btn>
          </td> -->
          <td>{{ item.no }}</td>

          <!-- Display index number -->
          <!-- <td style="font-size: 8px;">{{ contact.project }}</td>
          <td width="3%" style="font-size: 8px;">{{ contact.source }}</td> -->
          <!-- <td style="font-size: 10px;">{{ contact.name }}</td> -->
          <td>
            <input type="text" v-model="item.name">
          </td>

          <td>
            <input type="text" v-model="item.language">
          </td>
          <td>
            <input type="text" v-model="item.phoneNumber">
          </td>

          <td>
            <textarea v-model="item.interaction"></textarea>
          </td>

          <td>
            <input type="text" v-model="item.status">
          </td>

          <td>
            <input type="text" v-model="item.doc">
          </td>

          <td>
            <input type="text" v-model="item.called">
          </td>

          <td>
            <input type="text" v-model="item.contacted">
          </td>


          <td>{{ item.date }}</td>

          <td>
            <select v-model="item.lastCall">
              <option value="">Select a date</option>
              <option v-for="date in availableDates" :key="date" :value="date">
                {{ date }}
              </option>
            </select>
          </td>
          <td>

            <select v-model="item.nextCall">
              <option value="">Select a date</option>
              <option v-for="date in availableDates" :key="date" :value="date">
                {{ date }}
              </option>
            </select>
          </td>
          <td width="18%" style="font-size: 12px;">
            <input type="text" v-model="item.na1">
          </td>
          <!-- <td>{{ contact.lastCall }}</td>
          <td>{{ contact.nextCall }}</td> -->
        </tr>
      </template>
    </v-data-table>

  </div>
</template>


<script>
//

import { ref, watchEffect, watch, onMounted } from 'vue';
import { useMutation } from '@vue/apollo-composable';
import { gql } from '@apollo/client/core';
import cloneDeep from 'lodash/cloneDeep'; // Ensure lodash is properly imported
import html2pdf from 'html2pdf.js';
import Papa from 'papaparse';
import CountdownTimer from './CountdownTimer';
import axios from 'axios';
// import Papa from 'papaparse';


const UPDATE_CALLME = gql`
  # Write your query or mutation here
mutation(
  $id: ID!
  $no: Int
  $user: String
  $name: String
  $phoneNumber: String
  $status: String
  $interaction: String
  $lastCall: DateTime
  $nextCall: DateTime
) {
  updateMakeCall(
    id: $id
    data: {
      user: $user
      name: $name
      phoneNumber: $phoneNumber
      status: $status
      interaction: $interaction
      lastCall: $lastCall
      nextCall: $nextCall
      no: $no
    }
  ) {
    # Define the fields you want to be returned here

    data{
      id
      attributes{
    name
    phoneNumber
    status
    interaction
    lastCall
    nextCall
    no
    }
    }
  }
}

`;

// const CREATE_CALLME = gql`
// mutation (
//   $name: String
//   $status:String
//   $no: Int
//   $user: String
//   $phoneNumber: String
//   $interaction: String
//   $lastCall: DateTime
//   $nextCall: DateTime
//  ) {
//   createMakeCall(
//     data: {
//       name: $name
//       status: $status
//      no: $no
//   user: $user
//   phoneNumber: $phoneNumber
//   interaction: $interaction
//   lastCall: $lastCall
//   nextCall: $nextCall
//      }
//   ) {
//     data {
//       id
//     }
//   }
// }`

// const QUERY_CALLME = gql`
//   query($user: String!) {
//   makeCalls(filters: { user: { eq: $user } }, pagination: { limit: 1000 }) {
//     data {
//       id
//       }
//     }
//   }




// `




export default {
  name: 'ContactList',
  props: {
    projectKey: {
      type: String,
      required: true
    },
    enDate: {
      type: String,
      required: true
    }
  },
  components: {
    vSelect: window["vue-select"],
    CountdownTimer
  },
  setup() {
    const contacts = ref([]);
    const currentIndex = ref(0); // Initialize currentIndex
    const dataRestored = ref(false); // Flag to check if data has been restored
    const selectedUser = ref(null);

    // const datas = ref([{id: 1, status: 1, items:[1,2,3]}, {id:2,  status: 2, items:[1,2,3]}, {id:3,  status: 3, items:[1,2,3]}]);

    onMounted(() => {
      const savedIndex = localStorage.getItem('currentIndex');
      if (savedIndex !== null) {
        currentIndex.value = parseInt(savedIndex, 10);
      }

      selectedUser.value = localStorage.getItem('user');
    });

    // Watch currentIndex and save it to localStorage whenever it changes
    watch(currentIndex, (newIndex) => {
      if (newIndex === null) {
        const savedIndex = localStorage.getItem('currentIndex');
        if (savedIndex !== null) {
          currentIndex.value = parseInt(savedIndex, 10);
        }
      }
      else {
        localStorage.setItem('currentIndex', newIndex);
      }
    });


    watch(selectedUser, (newUser) => {
      localStorage.setItem('user', newUser);
    });

    // const convertYMD2DMY = (dateString) => {
    //   let [year, month, day] = dateString.split('-');
    //   month = month.padStart(2, '0');
    //   day = day.padStart(2, '0');
    //   return `${day}-${month}-${year.substring(2)}`;
    // };
    const todayDDMMYYYY = () => {
      const date = new Date();
      const day = String(date.getDate()).padStart(2, '0'); // Add leading zero if needed
      const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are 0-indexed
      const year = date.getFullYear();

      return `${day}/${month}/${year}`;
    };

    const convertDMY2YMD = (dateString) => {
      let [day, month, year] = dateString.replaceAll('/', '-').split('-');
      if (day < 1000) {  // convert only if day is not a year 
        month = month.padStart(2, '0');
        day = day.padStart(2, '0');
        return `${year}-${month}-${day}T00:00:00Z`;
      }
      else {
        return `${day}-${month}-${year}T00:00:00Z`;
      }
    };

    const { mutate: updateCallme } = useMutation(UPDATE_CALLME);


    const makeCall = async (contact) => {
      try {
        await new Promise(resolve => setTimeout(resolve));
        let { name, phoneNumber, status, interaction, lastCall, nextCall, no } = contact;
        lastCall = convertDMY2YMD(lastCall);
        nextCall = convertDMY2YMD(nextCall);


        let user = selectedUser;
        let id = 0;



        if (user.value.toLowerCase() === "alyssa") id = 3;
        if (user.value.toLowerCase() === "alvin") id = 4;
        if (user.value.toLowerCase() === "ashton") id = 2;


        const variables =
          { id: id, user: user.value, name: name, phoneNumber: phoneNumber, status: status, interaction: interaction, lastCall: lastCall, nextCall: nextCall, no: no }
        // {id,user ,name,phoneNumber, status, interaction, lastCall, nextCall,no}
        // {id:id,data:{user ,name,phoneNumber, status, interaction, lastCall, nextCall,no}}




        await updateCallme(variables);

        // console.log('Updated callme:', data.updateCallme.data);

        contact.called = (function (calledString) {
          // Attempt to convert the string to a number
          const numberValue = parseInt(calledString, 10);

          // Check if conversion was successful (is a number)
          if (!isNaN(numberValue)) {
            return numberValue + 1; // Increment the number
          } else {
            return 1; // Set to zero if not numeric
          }
        })(contact.called);

        contact.date = todayDDMMYYYY();
        // Perform any additional logic with the updated data

      } catch (error) {
        console.error('Error updating callme:', error);
        // Handle error appropriately
      }
      currentIndex.value = contacts.value.findIndex(c => c.no === contact.no);
    }

    const saveDataToLocalStorage = () => {
      console.log('Attempting to save data to local storage...');
      if (dataRestored.value) {
        try {
          const dataToSave = {
            contacts: contacts.value,
            // Add other properties as needed
          };
          localStorage.setItem('appData', JSON.stringify(dataToSave));
          console.log('Data saved to local storage:', dataToSave);
        } catch (error) {
          console.error('Error saving to local storage:', error);
        }
      } else {
        console.log('Data not saved: dataRestored.value is false');
      }
    };


    const restoreDataFromLocalStorage = () => {
      console.log('Attempting to restore data from local storage...');
      const savedData = localStorage.getItem('appData');
      if (savedData) {
        try {
          console.log('Saved data found in local storage:', savedData);
          const parsedData = JSON.parse(savedData);
          contacts.value = parsedData.contacts || [];
          // Restore other properties as needed
          dataRestored.value = true;
          console.log('Data restored from local storage:', parsedData);
        } catch (error) {
          console.error('Error parsing data from local storage:', error);
        }
      } else {
        console.log('No saved data found in local storage.');
      }
    };

    onMounted(() => {
      restoreDataFromLocalStorage();

      // Additional initialization logic if needed
    });

    // Watch contacts for changes and save to localStorage
    watchEffect(() => {
      console.log('watchEffect triggered, contacts:', contacts.value);
      //  saveDataToLocalStorage();
    });
    let initialContacts = cloneDeep(contacts.value);
    // Watch for changes in contacts
    watch(contacts, (newContacts) => {
      console.log('Contacts changed');

      // Check if there are any changes compared to the initial state
      let isDirty = false;

      // Ensure initialContacts and newContacts are arrays of the same length
      if (newContacts.length !== initialContacts.length) {
        isDirty = true;
      } else {
        for (let i = 0; i < newContacts.length; i++) {
          const newContact = newContacts[i];
          const initialContact = initialContacts[i];

          // Check if newContact or initialContact is undefined
          if (!newContact || !initialContact) {
            isDirty = true;
            break;
          }

          // Compare each field of newContact with initialContact
          for (const key in newContact) {
            if (newContact[key] !== initialContact[key]) {
              console.log(`Field '${key}' in contact ${newContact.id} changed`);
              isDirty = true;
              break; // No need to check further fields if one is different
            }
          }

          if (isDirty) break; // No need to check further contacts if one is different
        }
      }

      // If any data is dirty, save to localStorage and update the initialContacts
      if (isDirty) {
        dataRestored.value = true;
        saveDataToLocalStorage();
        initialContacts = cloneDeep(newContacts); // Update the initial state to the current state
      }
    }, { deep: true });

    return {
      restoreDataFromLocalStorage,
      makeCall,
      contacts,
      currentIndex,
      selectedUser
    };
  },
  mounted() {
    this.loadMessageFiles();
  },
  data() {
    return {
      filterTerm: '',
      sortOrder: {
        phoneNumber: 'asc',
        name: 'asc',
        no: 'asc',
        status: 'asc',
        nextCall: 'asc'
      },
      users: ["Alyssa", "Ashton", "Alvin"],

      countries: [
        { country: "Spain" },
        { country: "France" },
        { country: "Ghana" },
        { country: "Nigeria" },
        { country: "Brazil" },
        { country: "Ecuador" }
      ],


      headers: [
        { text: '', title: '', value: 'remove', width: '2%' },
        { text: '', title: '', value: 'send', width: '2%' },
        { text: '', title: '', value: 'call', width: '2%' },
        // { text: '', title: '', value: 'dial', width: '2%' },
        { text: 'No', title: 'No', value: 'no', width: '3%' },
        { text: 'Name', title: 'Name', value: 'name', width: '12%' },
        { text: 'Language', title: 'Lgn.', value: 'language', width: '3%' },
        { text: 'Phone', title: 'Phone', value: 'phoneNumber', width: '12%' },
        { text: 'Interaction', title: 'Interaction', value: 'interaction', width: '26%' },
        { text: 'Status', title: 'Status', value: 'status', width: '10%' },
        { text: 'Doc', title: 'Doc', value: 'doc', width: '5%' },
        { text: 'Called', title: 'Called', value: 'called', width: '4%' },
        { text: 'Contacted', title: 'Contacted', value: 'contacted', width: '3%' },
        { text: 'Dial Date', title: 'Dial', value: 'date', width: '5%' },
        { text: 'Last Called Date', title: 'Last Call', value: 'lastCall', width: '7%' },
        { text: 'Next Call', title: 'Next_Call', value: 'nextCall', width: '7%' },
        { text: 'Next Action', title: 'Next Action', value: 'na1', width: '5%' },
      ],
      availableDates: this.generateDateOptions(),
      messageEn: [],
      messageCn: [],
      messageBs: [],
      phoneNumber: '',
      sendmsg: "",
      whatsappmessage: '',
      findValue: null,
      //  currentIndex: 0,
      error: null,
      // contacts: [
      //   { no: 1, project: 'abc', source: 'uom', name: 'John', phoneNumber: '+601116331800', interaction: 'hello', message: '!ei2', status: '', na1: "w", date: "10-10-2024", email: "aa@bb.com", occupation: "IT", lastCall: "10-10-2024", nextCall: "10-10-2024" },
      //   { no: 2, project: 'abc', source: 'uom', name: 'Jane', phoneNumber: '+601116331801', interaction: '', message: '!ei2', status: '', na1: "w", date: "10-10-2024", email: "aa@bb.com", occupation: "IT", lastCall: "10-10-2024", nextCall: "10-10-2024" },
      //   { no: 3, project: 'abc', source: 'uom', name: 'Alex', phoneNumber: '+601116331802', interaction: '', message: '!ei2', status: '', na1: "w", date: "10-10-2024", email: "aa@bb.com", occupation: "IT", lastCall: "10-10-2024", nextCall: "10-10-2024" }
      //   // Add more contacts as needed
      // ],
    };
  },
  computed: {
    currentContact() {
      return this.contacts[this.currentIndex] || {};
    },
    //   filteredContacts() {
    //   if (this.filterTerm === '') {
    //     return this.contacts; // Show all records
    //   } else if (this.filterTerm.toLowerCase() === 'dup') {
    //     return this.getDuplicateRecords(); // Show only duplicate records
    //   } else {
    //     return this.contacts.filter(contact => {
    //       return Object.values(contact).some(value =>
    //         value.toString().toLowerCase().includes(this.filterTerm.toLowerCase())
    //       );
    //     });
    //   }
    // }

    filteredContacts() {
      if (this.filterTerm === '') {
        return this.contacts; // Show all records
      } else if (this.filterTerm.toLowerCase() === 'dup') {
        return this.getDuplicateRecords(); // Show only duplicate records
      } else {
        return this.contacts.filter(contact => {
          // Define the specific fields you want to search through
          const fieldsToSearch = [contact.name, contact.phoneNumber, contact.status]; // Add more fields if needed
          return fieldsToSearch.some(value =>
            value.toString().toLowerCase().includes(this.filterTerm.toLowerCase())
          );
        });
      }
    }
  },



  methods: {
    removeContact(index) {
      // Get the contact from the filtered list
      const contactToRemove = this.filteredContacts[index];

      // Confirm with the user before deleting
      const confirmation = confirm(`Are you sure you want to delete the contact: ${contactToRemove.name} (${contactToRemove.phoneNumber})?`);

      // If the user confirms, proceed with the deletion
      if (confirmation) {
        // Find the index of this contact in the original contacts array
        const originalIndex = this.contacts.findIndex(contact => contact === contactToRemove);

        // Debugging: Log the original index and the contact to be removed
        console.log('Removing contact at original index:', originalIndex);
        console.log('Contact:', this.contacts[originalIndex]);

        // Remove the contact from the original contacts array if it exists
        if (originalIndex !== -1) {
          this.contacts.splice(originalIndex, 1);
        }
      } else {
        // If the user cancels, log a message (optional)
        console.log('Contact removal canceled.');
      }
    },
    getDuplicateRecords() {
      const phoneNumberCount = this.contacts.reduce((acc, contact) => {
        const phoneNumber = contact.phoneNumber.trim();
        if (phoneNumber) {
          acc[phoneNumber] = (acc[phoneNumber] || 0) + 1;
        }
        return acc;
      }, {});

      const duplicateNumbers = Object.keys(phoneNumberCount).filter(number => phoneNumberCount[number] > 1);

      return this.contacts.filter(contact => duplicateNumbers.includes(contact.phoneNumber.trim()));
    },
    stopCountdownFromParent() {
      this.$refs.countdown.stopCountdown();
    },
    async sendMessage() {
      this.currentIndex = 0;
      while (this.currentIndex < this.contacts.length) {
        // Check if the current contact has already been sent a message
        if (this.contacts[this.currentIndex].status.trim() !== 'send' && this.contacts[this.currentIndex].phoneNumber.trim().length > 0) {
          const contact = this.contacts[this.currentIndex];
          let language = "e";

          if (contact.language !== undefined && contact.language.trim() !== "") {
            language = contact.language;
          }


          try {
            // if (contact.status.trim().length > 0) {
            //   alert(contact.status + ":" + contact.phoneNumber);

            // }

            let message = "!" + language + this.sendmsg;
            let msg = this.getmessage(message, contact);
            contact.status = "send";
            if (contact.doc !== undefined)
              contact.doc = this.sendmsg + contact.doc;
            else
              contact.doc = this.sendmsg


            //      alert("calling :" + contact.name + ":" +  contact.phoneNumber + ":"+ msg);

            const response = await axios.post('http://localhost:3000/send-message', {
              number: contact.phoneNumber,
              message: msg
            });

            if (response.data.success) {
              // Optionally handle successful message sending
            } else {
              alert('Failed to send message: ' + response.data.error);
              contact.status = "error 1 send";
              this.$refs.countdown.stopCountdown();
              return; // Exit the function if message sending fails
            }
          } catch (error) {
            console.error('Error:', error);
            contact.status = "error 2 send";
            alert('An error occurred: ' + error.message);
            this.$refs.countdown.stopCountdown();
            return; // Exit the function if an error occurs
          }
          this.currentIndex++;
          break;
        }
        // Move to the next contact
        this.currentIndex++;

      }

      if (this.currentIndex >= this.contacts.length) {
        this.$refs.countdown.stopCountdown();
        alert("send whatapp message completed");
      }
    },

    isVisible(contact) {
      if (this.filter === 'showAll') {
        return true; // Show all records
      }
      // Your existing filter logic
      // Example:
      return contact.phoneNumber && contact.phoneNumber.includes(this.searchTerm);
    },
    countdownFinished() {
      console.log("Countdown finished!");
      this.sendMessage();
      // You can add any additional logic you need here
    },
    sortContacts(property) {
      if (this.sortOrder[property] === 'asc') {
        this.contacts.sort((a, b) => {
          if (a[property] < b[property]) return -1;
          if (a[property] > b[property]) return 1;
          return 0;
        });
        this.sortOrder[property] = 'desc';
      } else {
        this.contacts.sort((a, b) => {
          if (a[property] < b[property]) return 1;
          if (a[property] > b[property]) return -1;
          return 0;
        });
        this.sortOrder[property] = 'asc';
      }
    }
    ,
    printTable() {

      html2pdf(document.getElementById('tableToPrint'), {
        filename: 'myFilename.pdf',
        jsPDF: { unit: 'in', format: 'A3', orientation: 'landscape', html2canvas: { scale: 2 } }
      });

      // const element = this.$refs.tableToPrint;
      // if (element) {
      //   html2pdf().from(element).save();
      // } else {
      //   console.error("Element not found");
      // }
    },


    rowClick(index) {
      // Set the selected index to highlight the row
      this.currentIndex = this.currentIndex === index ? null : index;
    },


    generateDateOptions() {
      const dates = [];
      const today = new Date();
      for (let i = 0; i < 30; i++) {
        const date = new Date(today);
        date.setDate(today.getDate() + i);

        const day = String(date.getDate()).padStart(2, '0'); // Get day and pad with leading zero if needed
        const month = String(date.getMonth() + 1).padStart(2, '0'); // Get month (zero-based) and pad with leading zero if needed
        const year = date.getFullYear(); // Get full year

        const formattedDate = `${day}/${month}/${year}`; // Format as DD/MM/YYYY
        dates.push(formattedDate);
      }
      return dates;
    },
    addPlus(np) {
      if (np.substring(0, 2) === "60")
        np = "+" + np;
      return np.replaceAll("@", "");
    },
    formatString(text) {
      if (text === undefined) {
        return '';
      }

      // Remove all non-numeric characters
      text = text.replace(/\D/g, '');

      if (text.length <= 12) {
        return text.padEnd(12, '_'); // Pad with underscores if shorter
      } else {
        return text.slice(0, 12); // Truncate if longer
      }
    },
    loadMessageFiles() {
      this.loadTextFile('/messageEn.txt', 'messageEn');
      this.loadTextFile('/messageCn.txt', 'messageCn');
      //  this.loadTextFile('/messageBs.txt', 'messageBs');

    },
    loadTextFile(filePath, lngName) {
      fetch(filePath)
        .then(response => response.text())
        .then(data => {
          console.log(`File loaded successfully: ${filePath}`);
          console.log(`Data: ${data}`);
          const lines = data.split('\n');
          const dataArray = [];
          let currentObject = { code: '', msg: '' };

          if (this.projectKey === "undefined") {
            alert("ProjectKey Not defined");
            return;
          }

          lines.forEach(line => {
            if (!line.startsWith('_')) {
              if (line.startsWith('@')) {
                if (currentObject.code !== '') {
                  dataArray.push(currentObject);
                }
                const [code, msg] = line.split('|');
                currentObject = { code: code.trim().substring(1), msg: msg.trim() + "\n" };
              } else {
                currentObject.msg += line.trim().replaceAll("$plink", "https://alvintkb.github.io/?p=gyp" + this.enDate + "$phone" + this.projectKey) + "\n";
              }
            }
          });

          if (currentObject.code !== '') {
            dataArray.push(currentObject);
          }

          this[lngName].splice(0, this[lngName].length, ...dataArray);
          if (this[lngName].length == 0) {
            alert("Error! " + lngName + " no data");
          }
        })
        .catch(error => {
          console.error('Error loading text file:', error);
        });
    },
    sendmessage() {
      if (this.phoneNumber && this.whatsappmessage) {
        let msg = this.getmessage(this.whatsappmessage);

        const textarea = document.createElement('textarea');
        textarea.value = msg;
        document.body.appendChild(textarea);
        textarea.select();
        document.execCommand('copy');
        document.body.removeChild(textarea);

        const cleanedPhoneNumber = this.cleanPhoneNumber(this.phoneNumber);
        const url = `https://api.whatsapp.com/send?phone=${cleanedPhoneNumber}&text=${encodeURIComponent(msg)}`;
        window.open(url, '_blank');
      } else {
        alert('Please enter both telephone number and WhatsApp message.');
      }
    },
    jumpToIndex() {
      if (this.findValue >= 0 && this.findValue < this.contacts.length) {
        this.currentIndex = this.findValue - 1;
      } else {
        console.error("Invalid index.");
      }
    },
    findContactByNumber(phoneNumber) {
      return this.contacts.find(contact => contact.phoneNumber.includes(phoneNumber));
    },
    findNumber() {
      const matchingContact = this.findContactByNumber(this.findValue);
      if (matchingContact) {
        let i = this.contacts.indexOf(matchingContact);
        this.currentIndex = i;
      } else {
        console.error("No contact found with phone number containing", this.findValue);
      }
    },
    findName() {
      const matchingContact = this.findByName(this.findValue);
      if (matchingContact) {
        let i = this.contacts.indexOf(matchingContact);
        this.currentIndex = i;
      } else {
        console.error("No contact found with this name containing", this.findValue);
      }
    },
    findByName(name) {
      return this.contacts.find(contact => contact.name.toLowerCase().includes(name.toLowerCase()));
    },
    camelize(str) {
      return str.replace(/(?:^\w|[-\s]\w)/g, function (match) {
        return match.toUpperCase();
      }).replace(/[-_]/g, '');
    },
    sendViaWhatsApp(contact) {



      if (!this.validateInput(this.sendmsg)) {
        this.sendmsg = 'a0';
      }
      const { phoneNumber, language } = contact;
      
      var message = '!' + (language || 'e') + this.sendmsg;
      let msg = this.getmessage(message, contact);

      const textarea = document.createElement('textarea');
      textarea.value = msg;
      document.body.appendChild(textarea);
      textarea.select();
      document.execCommand('copy');
      document.body.removeChild(textarea);

      const cleanedPhoneNumber = this.cleanPhoneNumber(phoneNumber);
      const url = `https://api.whatsapp.com/send?phone=${cleanedPhoneNumber}&text=${encodeURIComponent(msg)}`;
      window.open(url, '_blank');

      if (this.contacts[this.currentIndex].doc.lenght > 0)
        this.contacts[this.currentIndex].doc += "," + this.sendmsg;
      else
        this.contacts[this.currentIndex].doc += this.sendmsg;
      this.currentIndex = this.contacts.findIndex(c => c.no === contact.no);
    },
    sendwhatsappmessage() {
      const { phoneNumber, na1, name, message } = this.currentContact;
      if (na1 !== 'w') {
        this.moveToNextContact();
        return;
      }
      if (this.validateInput(na1)) {
        let msg = this.getmessage(message);
        msg = msg.replaceAll("@name", name);
        msg = msg.replaceAll("$phone", this.formatString(this.contacts[this.currentIndex].phoneNumber));

        const textarea = document.createElement('textarea');
        textarea.value = msg;
        document.body.appendChild(textarea);
        textarea.select();
        document.execCommand('copy');
        document.body.removeChild(textarea);

        const cleanedPhoneNumber = this.cleanPhoneNumber(phoneNumber);
        const url = `https://api.whatsapp.com/send?phone=${cleanedPhoneNumber}&text=${encodeURIComponent(msg)}`;
        window.open(url, '_blank');

        this.moveToNextContact();
      }
    },
    getmessage(message, contact) {

      let msg = "";

      if (message.slice(0, 2) === "!c")
        msg = this.messageCn.find(msg => msg.code === message.slice(1)).msg;
      // else if (message.slice(0, 2) === "!b")
      //   msg = this.messageBs.find(msg => msg.code === message.slice(1)).msg;
      else if (message.slice(0, 2) === "!e" || message.slice(0, 2) === "!b") {
        if (this.messageEn.length == 0) {
          alert("No Data");
          msg = "";
        }
        else
          msg = this.messageEn.find(msg => msg.code === message.slice(1)).msg;
      }
      else {
        alert("message error on 1st character, only allow e c b:" + message);
      }
      msg = msg.replaceAll("@name", contact.name);
      msg = msg.replaceAll("@project", this.camelize(contact.project));
      msg = msg.replaceAll("$phone", this.formatString(contact.phoneNumber));

      return msg;
    },
    validateInput(message) {
      if (!message) {
        // alert('Please enter a message.');
        //  this.error = 'Please enter a message.';
        return false;
      }
      this.error = null;
      return true;
    },
    moveToNextContact() {
      let checkedContacts = 0;
      do {
        this.currentIndex++;
        if (this.currentIndex >= this.contacts.length) {
          this.currentIndex = 0;
          checkedContacts++;
          if (checkedContacts >= this.contacts.length) {
            break;
          }
        }
      } while (this.contacts[this.currentIndex].na1 !== 'w');
    },
    startProcessing() {
      this.currentIndex = 0;
      let checkedContacts = 0;
      while (this.contacts[this.currentIndex].na1 !== 'w') {
        this.moveToNextContact();
        checkedContacts++;
        if (checkedContacts >= this.contacts.length) {
          break;
        }
      }
    },

    loadJSONFile(event) {
      const file = event.target.files[0];
      if (!file) {
        this.error = 'Please select a file.';
        return;
      }
      localStorage.removeItem('appData');
      this.contacts = [];
      const reader = new FileReader();
      reader.onload = (e) => {
        try {
          const jsonData = JSON.parse(e.target.result);
          this.contacts = jsonData.map((contact, index) => ({
            no: index + 1,
            name: contact.name ? contact.name.trim() : '',
            language: contact.language ? contact.language.trim() : '',
            phoneNumber: contact.phoneNumber ? this.addPlus(contact.phoneNumber.trim()) : '',
            email: contact.email ? String(contact.email).trim() : '',
            status: contact.status ? contact.status.trim() : '',
            date: contact.date ? contact.date.trim() : '1-1-1900',
            project: contact.project ? contact.project.trim() : '',
            source: contact.source ? contact.source.trim() : '',
            doc: contact.doc ? contact.doc.trim() : '',
            called: contact.called ? String(contact.called).trim() : '0',
            contacted: contact.contacted ? String(contact.contacted).trim() : '0',
            occupation: contact.occupation ? contact.occupation.trim() : '',
            na1: contact.na1 ? contact.na1.trim() : '',
            message: contact.message ? contact.message.trim() : '',
            interaction: contact.interaction ? contact.interaction.trim() : '',
            nextCall: contact.nextCall ? contact.nextCall.trim() : '1-1-1900',
            lastCall: contact.lastCall ? contact.lastCall.trim() : '1-1-1900',
            edit: false,
            editField: ''
          }));

          // Sort contacts by phoneNumber
          this.contacts.sort((a, b) => {
            if (a.phoneNumber < b.phoneNumber) return -1;
            if (a.phoneNumber > b.phoneNumber) return 1;
            return 0;
          });
          // Remove duplicates
          this.removeDuplicatePhoneNumbers();
        } catch (error) {
          console.error('Error parsing JSON file:', error);
          this.error = 'Error parsing JSON file.';
        }
      };
      reader.onerror = (error) => {
        console.error('Error reading file:', error);
        this.error = 'Error reading file.';
      };
      reader.readAsText(file);
    },
    formatPhoneNumber(phoneNumber) {
      if (!phoneNumber.startsWith("@")) {
        return "@" + phoneNumber;
      }
      return phoneNumber;
    },
    removeDuplicatePhoneNumbers() {
      const seen = new Set();
      this.contacts = this.contacts.filter(contact => {
        // Check if the phoneNumber is blank or already seen
        if (!contact.phoneNumber || seen.has(contact.phoneNumber)) {
          return false;
        } else {
          seen.add(contact.phoneNumber);
          return true;
        }
      });
    },
    loadCSVFile(event) {
      const file = event.target.files[0];
      if (!file) {
        this.error = 'Please select a file.';
        return;
      }

      const reader = new FileReader();
      reader.onload = (e) => {
        const csvData = e.target.result;
        Papa.parse(csvData, {
          header: true,
          complete: (results) => {
            const newContacts = results.data.map((contact, index) => ({
              no: index + 1,
              name: contact.name ? contact.name.trim() : '',
              phoneNumber: contact.phoneNumber ? this.addPlus(contact.phoneNumber.trim()) : '',
              email: contact.email ? contact.email.trim() : '',
              status: contact.status ? contact.status.trim() : '',
              date: contact.date ? contact.date.trim() : "1-1-1900",
              project: contact.project ? contact.project.trim() : '',
              source: contact.source ? contact.source.trim() : '',
              occupation: contact.occupation ? contact.occupation.trim() : '',
              na1: contact.na1 ? contact.na1.trim() : '',
              message: contact.message ? contact.message.trim() : '',
              interaction: contact.interaction ? contact.interaction.trim() : '',
              nextCall: contact.nextCall ? contact.nextCall.trim() : "1-1-1900",
              lastCall: contact.lastCall ? contact.lastCall.trim() : "1-1-1900",
              edit: false,
              editField: ''
            }));
            this.promptUser(newContacts);
            this.resetFileInput();
          },
          error: (error) => {
            console.error('Error parsing CSV file:', error);
            this.error = 'Error parsing CSV file.';
            this.resetFileInput();
          }
        });
      };
      reader.readAsText(file);
    },
    resetFileInput() {
      // Reset the file input value so that the same file can be selected again
      this.$refs.fileInput.value = '';
    },
    promptUser(newContacts) {
      if (confirm('Do you want to overwrite the existing contacts? Click "OK" to overwrite, "Cancel" to append.')) {
        this.contacts = newContacts;
      } else {
        this.contacts = [...this.contacts, ...newContacts];
        //   this.removeDuplicatePhoneNumbers();
      }
    },

    exportToJSON() {
      const jsonData = JSON.stringify(this.contacts, null, 2);
      const blob = new Blob([jsonData], { type: 'application/json;charset=utf-8;' });
      const link = document.createElement('a');
      const url = URL.createObjectURL(blob);
      link.setAttribute('href', url);
      link.setAttribute('download', 'contacts.json');
      link.style.visibility = 'hidden';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    },
    editField(contact, field) {
      contact.edit = true;
      contact.editField = field;
    },
    saveField(contact) {
      contact.edit = false;
      contact.editField = '';
    },



  }


};
</script>


<style scoped>
.sort-button {
  padding: 10px 20px;
  font-size: 14px;
  border: none;
  border-radius: 5px;
  background-color: #007bff;
  color: white;
  cursor: pointer;
  transition: background-color 0.3s ease;
}

.highlight {
  background-color: yellow;
}

.selected {
  background-color: lightblue;
}

table {
  width: 100%;
  border-collapse: collapse;
  overflow-x: auto;
}

th,
td {
  border: 1px solid #ddd;
  padding: 8px;
}

th {
  background-color: #f2f2f2;
}

.col-no {
  width: 50px;
}

.col-name {
  width: 150px;
}


.col-phone {
  width: 150px;
}

.col-email {
  width: 250px;
}

.col-status {
  width: 100px;
}

.col-date {
  width: 150px;
}

.col-na1 {
  width: 100px;
}

.bordered-input {
  border: 1px solid #ccc;
  /* Adjust border color as needed */
  padding: 5px;
  /* Adjust padding as needed */
  border-radius: 4px;
  /* Add rounded corners for a more polished look */
}

/* Optional: Style the input based on the "selected" color (if desired) */
input[color="selected"] {
  border-color: blue;
  /* Or any other color you prefer */
}

.fixed-header {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  background-color: #fff;
  /* Change as needed */
  z-index: 1000;
  /* Ensure it is above other content */
  box-shadow: 0 -2px 4px rgba(0, 0, 0, 0.1);
  /* Optional, for visual effect */
}

.search-container {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 10px;
}

.half-width {
  width: 20%;
}

.pdf-container {
  width: 1800px;
  /* Set the desired width */
  margin: 0 auto;
  /* Center align the container if needed */
  /* Add other styling as needed */
}
</style>
